import { isNull, isEmptyArray, deepClone, isNullObj, isArray } from '@/utils/validateBase'
import { Utils } from './utils'
import { CommonDTO } from '../DTO/index';
/**
 * 计算药品重量
 */
export function computeWeight(list, _this) {
  list.forEach(item => {
    let goodsWeight = 0;
    if (!isNull(item.items)) {
      item.items.forEach(obj => {
        if (obj.itemNum && (obj.itemUnit || '').trim() && (obj.itemUnit || '').trim() == 'g') goodsWeight = _this.$bigNumber(obj.itemNum, '+', goodsWeight)
      })
      item.weight = goodsWeight
    }
  })
}

/**
 * 计算处方总价和药品小计
 */
export function computeRecipesTotal(list, _this) {
  list.forEach(item => {
    let totalPrice = 0;
    if (!isNull(item.items)) {
      item.items.forEach(obj => {
        if (obj.itemNum && obj.price) {
          let totalNum = _this.$bigNumber(obj.itemNum, '*', isNull(item.doseNum) ? 1 : item.doseNum)
          obj.totalPrice = _this.$bigNumber(totalNum, '*', obj.price, 2);
          if (item.recipeType == '1') {
            if (obj.isOwned && obj.isOwned == '0') { totalPrice = _this.$bigNumber(totalPrice, '+', obj.totalPrice) }
          } else {
            totalPrice = _this.$bigNumber(totalPrice, '+', obj.totalPrice)
          }
        }
      })
    }
    item.totalPrice = totalPrice
  })
}
//用于收费页面的计算
export function computeRecipesTotalPricingDetails(list, _this) {
  list.forEach(item => {
    let totalPrice = 0;
    if (!isNull(item.items)) {
      item.items.forEach(kid => {
        if (kid.commodityType !== 1) {
          kid.totalPrice = 0
          kid.items && kid.items.forEach(obj => {
            if (obj.itemTotal && obj.price) {
              let tempPrice = _this.$bigNumber(obj.itemTotal, '*', obj.price, 2);
              kid.totalPrice = _this.$bigNumber(kid.totalPrice, '+', tempPrice);
            }
          })
        }
        if (item.recipeType == '1') {
          if (kid.isOwned && kid.isOwned == '0') { totalPrice = _this.$bigNumber(totalPrice, '+', kid.totalPrice) }
        } else {
          if (kid.commodityType === 1) {
            totalPrice = _this.$bigNumber(totalPrice, '+', (Math.round(kid.itemTotal * 0.01 * 100) / 100))
          } else {
            totalPrice = _this.$bigNumber(totalPrice, '+', kid.totalPrice)
          }
        }
      })
    }
    item.totalPrice = totalPrice
  })
}

/**
 * 计算划价单总价
 */
export function computePricingTotal(_this) {
  let list = deepClone(_this.recipesList)
  let totalPrice = 0;
  // 快递费
  if (!isNull(_this.deliveryObj) && !isNullObj(_this.deliveryObj)) totalPrice = _this.$bigNumber(_this.deliveryObj.price, '+', totalPrice)
  // 挂号费
  if (!isNull(_this.registerPrice)) totalPrice = _this.$bigNumber(_this.registerPrice, '+', totalPrice)
  // 加工费 和 商品
  list.forEach(item => {
    totalPrice = _this.$bigNumber(totalPrice, '+', item.totalPrice)
    if (!isNull(item.processFlag) && item.processFlag == '1') {
      totalPrice = item.isYlcp == '1' ? _this.$bigNumber(totalPrice, '+', _this.$bigNumber(item.process.processPrice, '*', item.doseNum)) : _this.$bigNumber(totalPrice, '+', item.process.processPrice)
    }
  })
  _this.totalPrice = totalPrice
}
export function computePricingTotalNew(_this) {
  let list = deepClone(_this.recipesList)
  let actList = deepClone(_this.actList)
  let totalPrice = 0;
  // 快递费
  if (!isNull(_this.drugWayDeliveryBOS) && isArray(_this.drugWayDeliveryBOS)) {
    let price = 0;
    _this.drugWayDeliveryBOS.forEach(v => {
      price = price + Number(v.price)
    })
    price = Math.round(price * 100) / 100;
    totalPrice = _this.$bigNumber(price, '+', totalPrice)
  }
  // 挂号费
  if (!isNull(_this.registerPrice)) totalPrice = _this.$bigNumber(_this.registerPrice, '+', totalPrice)
  // 加工费
  if (!isNull(_this.processBOS) && isArray(_this.processBOS)) {
    let price = 0;
    _this.processBOS.forEach(v1 => {
      v1.processBOS.forEach(v2 => {
        let processPrice = 0;
        if (v1.recipeType === 5) {
          processPrice = Number(v2.processPrice) * Number(v2.dosage)
        } else {
          processPrice = Number(v2.processPrice)
        }
        price = price + processPrice
      })
    })
    price = Math.round(price * 100) / 100;
    totalPrice = _this.$bigNumber(price, '+', totalPrice)
  }
  // 商品
  list.forEach(item => {
    totalPrice = _this.$bigNumber(totalPrice, '+', item.totalPrice)
  })
  actList.forEach(item => {
    totalPrice = _this.$bigNumber(totalPrice, '+', item.totalPrice)
  })
  _this.totalPrice = totalPrice
}


export function computeRecipePrice(obj, _this) {
  let totalPrice = '0.00';
  let drugPrice = '0.00'
  let { recipeDrugItem, doseNumber } = obj
  if (isNull(obj.recipeDrugItem)) return totalPrice;
  recipeDrugItem.forEach(item => {
    let tempTotal = _this.$bigNumber(item.number, '*', item.price)
    item.totalPrice = tempTotal
    drugPrice = _this.$bigNumber(drugPrice, '+', _this.$bigNumber(tempTotal, '*', doseNumber), 2)
    totalPrice = _this.$bigNumber(totalPrice, '+', _this.$bigNumber(tempTotal, '*', doseNumber), 2)
  })
  obj.drugPrice = drugPrice;
  totalPrice = _this.$bigNumber(totalPrice, '+', isNull(obj.processingPrice) ? 0 : obj.processingPrice, 2)
  // obj.realPay = totalPrice
  return totalPrice;
}

/**
 * 计算隐秘处方总价
 */
export function computeComboTotalPrice(obj, _this) {
  let drugPrice = '0.00'
  let totalPrice = '0.00'
  obj.comboItems.forEach(item => {
    if (item.artNo != '0') drugPrice = _this.$bigNumber(drugPrice, '+', item.totalPrice, 2)
  })
  obj.drugPrice = drugPrice
  // obj.realPay = _this.$bigNumber(obj.totalPrice, '*', obj.doseNumber, 2)
  totalPrice = _this.$bigNumber(obj.totalPrice, '*', obj.doseNumber, 2);
  return totalPrice;
}

/**
 * 计算理疗处方总价
 */
export function computePhyTotalPrice(obj, _this) {
  let totalPrice = '0.00';
  if (isNull(obj.recipePhysioItem)) return totalPrice;
  obj.recipePhysioItem.forEach(item => {
    item.totalPrice = _this.$bigNumber(item.price, '*', item.number, 2)
    totalPrice = _this.$bigNumber(item.totalPrice, '+', totalPrice, 2)
  })
  // obj.realPay = totalPrice
  return totalPrice;
}

/**
 * 计算辅料总价
 */
export function computeIngredintTotal(obj, _this) {
  let totalPrice = '0.00'
  obj.forEach(item => {
    item.totalPrice = _this.$bigNumber(item.number, '*', item.price, 2)
    totalPrice = _this.$bigNumber(totalPrice, '+', item.totalPrice)
  })
  return totalPrice
}

/**
 * 计算物料总价
 */
export function computeMaterialTotal(obj, _this) {
  let totalPrice = '0.00'
  obj.forEach(item => {
    item.totalPrice = _this.$bigNumber(item.number, '*', item.price, 2)
    totalPrice = _this.$bigNumber(totalPrice, '+', item.totalPrice)
  })
  return totalPrice
}

/**
 * 计算订单总价
 */
export function computeOrderTotal(_this) {
  if (!isNull(_this.ctOrderIds) && !isEmptyArray(_this.ctOrderIds)) return;

  let { discountType, discount } = _this.chargeInfo
  let totalPrice = '0.00'
  // let realPay = '0.00'
  let drugPrice = '0.00'
  let weight = 0;
  let doseNumber = 0
  let paid = 0.00;
  let payList = _this.payList;
  if (!isNull(payList) && !isEmptyArray(payList)) {
    payList.forEach(item => {
      if (item.paySuccess == '1') paid = _this.$bigNumber(paid, '+', item.payPrice, 2)
    })
  }
  //中药处方总价
  if (!isEmptyArray(_this.orderRecipeDrug)) {
    _this.orderRecipeDrug.forEach(item => {
      weight = _this.$bigNumber(weight, '+', item.weight)
      doseNumber = _this.$bigNumber(doseNumber, '+', item.doseNumber)
      totalPrice = _this.$bigNumber(item.totalPrice, '+', totalPrice, 2)
      // if (discountType == '1') {
      //     let tempPrice = _this.$bigNumber(item.totalPrice, '-', item.drugPrice) //除开药品以外的总价
      //     let drugTotal = _this.$bigNumber(_this.$bigNumber(discount, '*', item.drugPrice), '/', 100, 2);
      //     item.realPay = _this.$bigNumber(tempPrice, '+', drugTotal)
      // } else {
      //     item.realPay = _this.$bigNumber(_this.$bigNumber(discount, '*', item.totalPrice), '/', 100, 2);
      // }
      // if (!isNull(item.processingPrice)) totalPrice = _this.$bigNumber(item.processingPrice, '+', totalPrice)
      drugPrice = _this.$bigNumber(drugPrice, '+', item.drugPrice)
    })
  }
  //隐秘处方总价
  if (!isEmptyArray(_this.orderRecipeCombo)) {
    _this.orderRecipeCombo.forEach(item => {
      doseNumber = _this.$bigNumber(doseNumber, '+', item.doseNumber)
      weight = _this.$bigNumber(weight, '+', item.weight)
      totalPrice = _this.$bigNumber(item.totalPrice, '+', totalPrice)
      drugPrice = _this.$bigNumber(drugPrice, '+', item.drugPrice)
      // item.realPay = _this.$bigNumber(_this.$bigNumber(discount, '*', item.totalPrice), '/', 100, 2);
    })
  }
  //理疗处方总计
  if (!isEmptyArray(_this.orderRecipePhysio)) {
    _this.orderRecipePhysio.forEach(item => {
      totalPrice = _this.$bigNumber(item.totalPrice, '+', totalPrice)
      // item.realPay = _this.$bigNumber(_this.$bigNumber(discount, '*', item.totalPrice), '/', 100, 2);
    })
  }
  // 挂号费
  if (!isNull(_this.editForm.registerPrice)) totalPrice = _this.$bigNumber(_this.editForm.registerPrice, '+', totalPrice)
  // 辅料费
  if (!isNull(_this.ingredientTotal)) totalPrice = _this.$bigNumber(_this.ingredientTotal, '+', totalPrice)
  // 物料费
  if (!isNull(_this.materialTotal)) totalPrice = _this.$bigNumber(_this.materialTotal, '+', totalPrice)
  // 快递费
  if (!isNull(_this.deliveryPrice)) totalPrice = _this.$bigNumber(_this.deliveryPrice, '+', totalPrice)
  // if(!isEmptyArray(_this.))
  // if (discountType == '0') {
  //     let registerPrice = _this.editForm.registerPrice;
  //     // 整单议价
  //     realPay = _this.$bigNumber(realPay, '-', registerPrice) //挂号费不能打折
  //     realPay = _this.$bigNumber(_this.$bigNumber(totalPrice, '*', discount), '/', 100, 2)
  // } else {
  //     // 药品议价
  //     let tempPrice = _this.$bigNumber(totalPrice, '-', drugPrice) //除开药品以外的总价
  //     let drugTotal = _this.$bigNumber(_this.$bigNumber(discount, '*', drugPrice), '/', 100, 2);
  //     realPay = _this.$bigNumber(tempPrice, '+', drugTotal)
  // }
  _this.chargeInfo.totalPrice = totalPrice
  _this.chargeInfo.realPay = totalPrice
  _this.chargeInfo.paid = paid
  _this.chargeInfo.unpaid = _this.$bigNumber(_this.chargeInfo.realPay, "-", paid, 2)
  _this.chargeInfo.drugPrice = drugPrice
  _this.chargeInfo.weight = weight
  _this.chargeInfo.doseNumber = doseNumber
}

/**
 * 分摊规则
 * 1. 折扣比例= 折后总金额 / 总金额（四舍五入，保留4位小数）
 * 2. 折后单价 = 折前单价*折扣比例 （四舍五入，保留4位小数）
 * 3. 折后小计 = 折后单价 * 数量 （四舍五入，保留2位小数）
 * 4. 计算差额 = 折后小计合计 - 折后金额
 * 5. 若相等，结束。 若不相等，随机选择一个商品的矫正折后小计=折后小计-差额，该商品的矫正折后单价 = 矫正折后小计 / 数量 （四舍五入，保留4位小数），建议优先分摊至不可以刷医保的商品，建议数量从小到大
 * 6. 各商品的议价 = 矫正折后小计 - 折前小计
 * 最终：记录矫正折后小计、矫正折后单价
 * 备注：仅会分摊至订单参与折扣的商品中，本期需求：整单议价（除开挂号费）
 */
/**
 * 计算每项数据的折后单价和折后小计
 * discount 折扣（两位小数）
 * casreceiptsh 实际首款
 */
export function handleApportion(_this, discount, casreceiptsh) {
  console.log(casreceiptsh, 44343);
  let newTotalPrice = 0;
  let dis = _this.$bigNumber(discount, '/', 100) //4位小数
  let newDeliveryPrice = 0;
  let newDrugList = deepClone(_this.orderRecipeDrug);
  let newComboList = deepClone(_this.orderRecipeCombo);
  let newPhysioList = deepClone(_this.orderRecipePhysio);
  let newMaterialList = deepClone(_this.materialList)
  if (!isNull(_this.deliveryPrice)) newDeliveryPrice = _this.$bigNumber(_this.deliveryPrice, '*', dis, 2); //折后快递费
  newTotalPrice = _this.$bigNumber(newTotalPrice, '+', newDeliveryPrice)
  // 中药处方
  if (!isNull(newDrugList) && !isEmptyArray(newDrugList)) {
    newDrugList.forEach(item => {
      if (!isNull(item.processingPrice)) {
        item.newProcessingPrice = _this.$bigNumber(item.processingPrice, '*', dis, 4) //折后加工费
        newTotalPrice = _this.$bigNumber(newTotalPrice, '+', item.newProcessingPrice)
      }
      if (!isNull(item.recipeDrugItem) && !isEmptyArray(item.recipeDrugItem)) {
        item.recipeDrugItem.forEach(obj => {
          obj.newNumber = _this.$bigNumber(obj.number, '*', item.doseNumber) //数量总计=数量*付数
          obj.newPrice = _this.$bigNumber(obj.price, '*', dis, 4) //折后单价
          obj.newTotalPrice = _this.$bigNumber(obj.newPrice, '*', obj.newNumber, 2) //折后小计
          newTotalPrice = _this.$bigNumber(newTotalPrice, '+', obj.newTotalPrice)
        })
      }
    })
  }
  //隐秘处方
  if (!isNull(newComboList) && !isEmptyArray(newComboList)) {
    newComboList.forEach(item => {
      if (!isNull(item.comboItems) && !isEmptyArray(item.comboItems)) {
        item.comboItems.forEach(obj => {
          obj.newNumber = _this.$bigNumber(obj.number, '*', item.doseNumber) //数量总计=数量*付数
          obj.newPrice = _this.$bigNumber(obj.price, '*', dis, 4) //折后单价
          obj.newTotalPrice = _this.$bigNumber(obj.newPrice, '*', obj.newNumber, 2) //折后小计
          newTotalPrice = _this.$bigNumber(newTotalPrice, '+', obj.newTotalPrice)
        })
      }
    })
  }

  //理疗处方
  if (!isNull(newPhysioList) && !isEmptyArray(newPhysioList)) {
    newPhysioList.forEach(item => {
      if (!isNull(item.recipePhysioItem) && !isEmptyArray(item.recipePhysioItem)) {
        item.recipePhysioItem.forEach(obj => {
          obj.newPrice = _this.$bigNumber(obj.price, '*', dis, 4) //折后单价
          obj.newTotalPrice = _this.$bigNumber(obj.newPrice, '*', obj.number, 2) //折后小计
          newTotalPrice = _this.$bigNumber(newTotalPrice, '+', obj.newTotalPrice)
        })
      }
    })
  }

  //其他商品
  if (!isNull(newMaterialList) && !isEmptyArray(newMaterialList)) {
    newMaterialList.forEach(item => {
      item.newPrice = _this.$bigNumber(item.price, '*', dis, 4) //折后单价
      item.newTotalPrice = _this.$bigNumber(item.newPrice, '*', item.number, 2) //折后小计
      newTotalPrice = _this.$bigNumber(newTotalPrice, '+', item.newTotalPrice)
    })
  }
  //判断折后总价是否等于应收
  console.log(newTotalPrice, 33333);
  if (!Utils.eq(newTotalPrice, casreceiptsh)) {
    // 不相等，随机找一个数量小于100的商品均摊多余的钱
    apportionToOne(newDrugList, newComboList, newPhysioList, newMaterialList, deliveryPrice, newDeliveryPrice,)
  }

  // return { newDrugList, newComboList, newPhysioList, newMaterialList, newDeliveryPrice }
}

/**
 * 分摊到具体某一个商品
 */
export function apportionToOne(drugList, comboList, physioList, materialList, deliveryPrice, newDeliveryPrice, _this) {
  let arr = [] //将所有带有价格的药品、加工费、配送当做一个商品放入到数组中
  arr.push({
    artCode: 'DELIVERY', //商品货号
    artName: '快递费', //商品名称
    artNum: 1, //商品数量
    originalUnitPrice: deliveryPrice, //商品折前单价
    originalPrice: deliveryPrice, //商品折前小计
    bargainUnitPrice: newDeliveryPrice, //商品折后单价
    bargainPrice: newDeliveryPrice //商品折后小计
  }) //快递费
  if (!isNull(materialList) && !isEmptyArray(materialList)) {
    materialList.forEach(item => {
      arr.push({
        artCode: item.id, //商品货号
        artName: '其他商品', //商品名称
        artNum: item.number, //商品数量
        originalUnitPrice: item.price, //商品折前单价
        originalPrice: item.totalPrice, //商品折前小计
        bargainUnitPrice: item.newPrice, //商品折后单价
        bargainPrice: item.newTotalPrice //商品折后小计
      }) //其他商品
    })
  }
  if (!isNull(drugList) && !isEmptyArray(drugList)) {
    drugList.forEach(item => {
      arr.push({
        artCode: `DRUG_PROCESS:${item.orderNumber}`, //商品货号
        artName: '处方加工费', //商品名称
        artNum: 1, //商品数量
        originalUnitPrice: item.processingPrice, //商品折前单价
        originalPrice: item.processingPrice, //商品折前小计
        bargainUnitPrice: item.newProcessingPrice, //商品折后单价
        bargainPrice: item.newProcessingPrice //商品折后小计
      }) //处方加工费
      item.recipeDrugItem.forEach(obj => {
        arr.push({
          artNo: obj.artNo, //商品货号
          artCode: obj.artNo, //商品货号
          artName: obj.drugName, //商品名称
          artNum: _this.$bigNumber(obj.number, '*', item.doseNumber), //商品数量
          originalUnitPrice: obj.price, //商品折前单价
          originalPrice: obj.totalPrice, //商品折前小计
          bargainUnitPrice: obj.newPrice, //商品折后单价
          bargainPrice: obj.newTotalPrice //商品折后小计
        }) //中药

      })
    })
  }
  if (!isNull(comboList) && !isEmptyArray(comboList)) {
    comboList.forEach(item => {
      item.comboItems.forEach(obj => {
        arr.push({
          artNo: obj.artNo, //商品货号
          artCode: obj.artNo, //商品货号
          artName: obj.drugName, //商品名称
          artNum: _this.$bigNumber(obj.number, '*', item.doseNumber), //商品数量
          originalUnitPrice: obj.price, //商品折前单价
          originalPrice: obj.totalPrice, //商品折前小计
          bargainUnitPrice: obj.newPrice, //商品折后单价
          bargainPrice: obj.newTotalPrice //商品折后小计
        })
      })
    })
  }
  if (!isNull(physioList) && !isEmptyArray(physioList)) {
    physioList.forEach(item => {
      item.recipePhysioItem.forEach(obj => {
        arr.push({
          artNo: obj.artNo, //商品货号
          artCode: obj.artNo, //商品货号
          artName: obj.physioName, //商品名称
          artNum: _this.$bigNumber(obj.number, '*', item.doseNumber), //商品数量
          originalUnitPrice: obj.price, //商品折前单价
          originalPrice: obj.totalPrice, //商品折前小计
          bargainUnitPrice: obj.newPrice, //商品折后单价
          bargainPrice: obj.newTotalPrice //商品折后小计
        })
      })
    })
  }
}